import { useTLang } from 'intl/intl';

export function useOrderDetailLang() {
  const _newText = useTLang({
    id: 'badge.new',
  });
  const _suggestionText = useTLang({
    id: 'adoption.suggestion',
  });
  const _scalePrintedDisclaimer = useTLang({
    id: 'adoption.scalePrinted',
  });
  const _handoffDisclaimer = useTLang({
    id: 'adoption.inputBagsDrinks',
  });

  return {
    text: {
      new: _newText,
      suggestion: _suggestionText,
    },
    disclaimer: {
      scalePrinted: _scalePrintedDisclaimer,
      handoff: _handoffDisclaimer,
    },
  };
}
